module.exports = __webpack_public_path__ + "media/vid_body_feature1.2dae5063.mp4";